'use client'

import { AppShell, AppShellProps, Sidebar } from '@saas-ui/react'

import { ImpersonationBanner } from '#features/admin/components/impersonation-banner'
import { PaymentOverdueBanner } from '#features/billing/components/payment-overdue-banner'

export interface AppLayoutProps extends AppShellProps {}

/**
 * Base layout for app pages.
 */
export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  sidebar,
  ...rest
}) => {
  return (
    <Sidebar.Provider variant="inset">
      <AppShell
        bg="sidebar.bg"
        sidebar={
          <>
            <Sidebar.FlyoutTrigger />
            {sidebar}
          </>
        }
        header={
          <>
            <ImpersonationBanner />
            <PaymentOverdueBanner />
          </>
        }
        {...rest}
      >
        <Sidebar.Inset>{children}</Sidebar.Inset>
      </AppShell>

      <Sidebar.Backdrop />
    </Sidebar.Provider>
  )
}
